// Default values for RecruitmentApply form
export const defaultValues = {
  is_active: 1,
  status: 1, // Mới ứng tuyển
  recruitment_id: null,
  recruitment_name: '',
  business_id: null,
  department_id: null,
  position_id: null,
  full_name: '',
  email: '',
  phone_number: '',
  dob: null,
  address: '',
  introduce: '',
  curriculum_vitae_url: '',
  apply_date: null,
  note: '',
  file_list: [],
};

// Status options
export const STATUS_OPTIONS = [
  { value: 1, label: 'Mới ứng tuyển' },
  { value: 2, label: 'Đạt yêu cầu' },
  { value: 3, label: 'Không đạt' },
];
